module.exports = __webpack_public_path__ + "img/rosepetal-dep-baxter-minerva.54f7ad06.jpg";